import * as _ from 'lodash';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Document } from 'ng2-app/modules/borrower/models/document/document.model';
import { DocumentService } from 'ng2-app/modules/borrower/models/document/document.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'document-attach',
    templateUrl: 'document-attach.component.html',
    styleUrls: ['document-attach.component.scss']
})

export class DocumentAttachComponent implements OnInit, OnDestroy {

    @Input() args = [];
    @Input() borrowerId;
    @Input() position;
    @Input() multiple = false;

    @Output() attached = new EventEmitter<Document[]>();

    isOpen = true;
    documents: Document[] = [];
    documentsSubscription: Subscription;
    selectedDocument: Document|null = null;

    constructor(protected documentService: DocumentService) {}

    @Input() docFilter = (docs) => docs;

    ngOnInit() {
        this.documentsSubscription = this.documentService.documentsForBorrower(this.borrowerId)
            .subscribe({
                next: (documents) => {
                    this.documents = this.docFilter(documents);
                    this.getIcon(this.documents);
                },
                error: (errors) => console.log(errors)
              });
    }

    ngOnDestroy() {
        this.documentsSubscription.unsubscribe();
    }

    cancel() {
        this.uncheckAll();
        this.isOpen = false;
    }

    uncheckAll() {
        _.forEach(this.documents, function (document) {
            document.checked = false;
        });
    }

    someChecked() {
        return _.some(this.documents, 'checked');
    }

    submit() {
        this.uncheckAll();
        this.isOpen = false;
        this.attached.next(this.selectedDocuments.filter(d => d !== null) as Document[]);
    }

    get selectedDocuments(): Array<any> {
        if (this.multiple) {
            return _.filter(this.documents, function (document) {
                return document.checked;
            });
        } else {
            return [this.selectedDocument];
        }
    }

    getIcon(documents) {
        documents.forEach(document => {
            let setIcon;
            const i = document.title.lastIndexOf('.');
            if (i === -1) {
                setIcon = 'file';
            }

            const ext = document.title.substring(i + 1, document.title.length).toLowerCase();
            if (ext === 'pdf') {
                setIcon = 'pdf';
            } else if (ext === 'doc' || ext === 'docx') {
                setIcon = 'word';
            } else if (ext.substring(0, 2) === 'xl') {
                setIcon = 'excel';
            } else if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' ||
            ext === 'gif' || ext === 'tiff' || ext === 'bmp') {
                setIcon = 'img';
            } else {
                setIcon = 'file';
            }
            document['icon'] = setIcon;
        });
    }

    documentId(i, document) {
        return document.id;
    }

}
